import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map } from 'rxjs/operators';
import { DataBuilder, Metadata } from "src/app/base/model/data-body-request";
import { DataBodyResponse } from "src/app/base/model/data-body-response";
import { UpdatePersonRepository } from "src/app/domain/repositories/update-person/update-person.repository";
import { UpdatePersonBuilder } from "src/app/domain/model/update-person/update-person-request";
import { TypePersonUpdate, TypePersonUtil } from "src/app/domain/model/TypePersonUpdate";
import { ProcessedDataResponse } from "src/app/base/model/processed-data-response";
import { StorageService } from "src/app/services/storage.service";


@Injectable({
    providedIn: 'root',
})
export class UpdatePersonImplementationRepository extends UpdatePersonRepository {
    urlServices = environment.urlServiceCommon;

    constructor(
        private http: HttpClient,
        protected storageService: StorageService
    ) {
        super(storageService);
    }

    updatePerson(
        params: {
            personId: number,
            typePersonUpdate: TypePersonUpdate,
            metadata: Metadata,
        }
    ): Observable<ProcessedDataResponse<any>> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const options = { headers };
        return this.http
            .post<DataBodyResponse<any>>(
                `${this.urlServices}/bid/rest/v1/people/upload`,
                this.buildUpdateRequest(params),
                options
            )
            .pipe(
                map(response => {
                    var processedDataResponse = new ProcessedDataResponse<any>()
                    processedDataResponse.code = response.code;
                    if (processedDataResponse.code != -9999) {
                        processedDataResponse.error = response?.error || response?.error != '' ? response?.error : 'Error en el servicio, intentar más tarde';
                    }
                    return processedDataResponse;
                })
            )
    }

    private buildUpdateRequest(
        params: {
            personId: number,
            typePersonUpdate: TypePersonUpdate,
            metadata: Metadata,
        }
    ) {
        let builder = new UpdatePersonBuilder()
        let dataBuilder = new DataBuilder()
        builder.buildAction(params.typePersonUpdate)
        console.log('Person action: ' + params.typePersonUpdate);
        builder.buildCatPersonType(2)
        builder.buildId(params.personId)
        dataBuilder.buildData(builder.getResult())
        this.getOperationID(dataBuilder)
        dataBuilder.buildMetaData(params.metadata)
        return dataBuilder.getResult()
    }
}